import { render, staticRenderFns } from "./DepartamentoListAddNew.vue?vue&type=template&id=acc2aa82&"
import script from "./DepartamentoListAddNew.vue?vue&type=script&lang=js&"
export * from "./DepartamentoListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./DepartamentoListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports